export const findWordLength = (word: string) => {
  return word.length > 0 ? word.trim().split(/[\n\s]+/).length : word.length;
};
